import React from 'react';
import ReactDOM from 'react-dom';

class NameFilter extends React.Component {
  constructor(props) {
    super(props); 
    this.state = {
      enteredText: props.query || ''
    }

    this._handleChange = this._handleChange.bind(this); 
  }
  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) {
     
      this.setState({ enteredText: this.props.query || '' });
    }
  }

  _handleChange(event) {
    this.setState({ enteredText: event.target.value },
      () => {
        this.props.onChange(this.state.enteredText);
      }); 

  }
  render() {

    return (
        <div className="input-group u-shadow-v21 rounded" style={{ zIndex: 99 }}>
          <input className="form-control form-control-sm" type="text" placeholder="Ride Name" onChange={this._handleChange} value={this.state.enteredText} /> 
        </div>

    );
  }
}
export default NameFilter;

